let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfVLK")).then(() => parcelRequire('KrQ6m'));